@if (isFaqStandard) {
  <app-admin-faq-list />
}
@if (isFaqCreate) {
  <app-admin-faq-create />
}
@if (isFaqEdit) {
  <app-admin-faq-edit />
}
